/**
 * 题目查看demo
 * @description 多种题型demo查看的demo
 * @author mll
 * @date 2020-1-21
 */
import React from 'react';
import { connect } from 'dva';

import { component_tool, framework_tool } from '../../../tool'
let {
    WizCard,
    WizButton,
    WizSearchBar,
    WizForm
} = component_tool;
let { WizContainer } = framework_tool;
import { WizTableForm } from '../../common'

class FormLinks extends WizContainer {

    componentName = 'FormLinks';

    constructor(props) {
        super(props);
        this.state = {
        }
    }


    _card = (title, icon = '0', r) => {
        return (<WizCard title={title} icon={icon}>{r}</WizCard>)
    }

    _searchBar = (columns) => {
        const searchBarProps = {
            columns,
            onSearch: values =>
                log.info('_searchBar onSearch:', values)
        };
        return (
            <WizSearchBar
                requestAnimationFrame type="grid"
                {...searchBarProps}
                cols={{ xs: 14, md: 12, xl: 10 }}
            />
        )
    }

    _form = (columns) => {
        let formProps = {
            ref: 'form',
            columns,
            onSubmit: values =>
                log.info('_form onSubmit:', values),
            record: null,
            preview: null,
            footer: undefined,
            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 17 }
            },
            style: {}
        }
        return (
            <WizForm className={'form-inline'} {...formProps} />
        )
    }

    render() {
        let columns = [
            {
                title: '状态',
                name: 'state',
                dict: [
                    { code: 1, codeName: '有效' },
                    { code: 0, codeName: '无效' },
                ],
                searchItem: {
                    type: 'select',
                },
                formItem: {
                    type: 'select',
                }
            },
            {
                title: '控制框内的内容',
                name: 'links',
                searchItem: {
                    type: 'diy',
                    links:'state',
                    diy: ({
                        linksValues
                    }) => {
                        log.info('linksValues:',linksValues)
                        return (
                            <div>{linksValues}</div>
                        )
                    }
                },
                formItem: {
                    type: 'diy',
                    links:{'state':'任职'},
                    ...WizTableForm.Config.organization(this, {}),
                    diy: WizTableForm
                }
            }
        ]
        return (
            <>
                {this._card('searchBar及联', 0, this._searchBar(columns))},
                {this._card('wizForm及联', 0, this._form(columns))}
            </>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {

    };
};

export default connect(mapStateToProps)(FormLinks);
